module.exports = __webpack_public_path__ + "fbc30867bbe10aad798b10b8e05deb31.svg";